import {DialogActions, DialogContent, Typography} from '@mui/material';
import {bool, func} from 'prop-types';

import {FONT_FAMILIES} from '../../../../const';
import useProjects from '../../../../hooks/providers/useProjects';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';

const DeleteEditorConnectionModal = ({isOpen, setIsOpen}) => {
  const {deleteEditorConnection, setCreateProjectModalOpen, connector} = useProjects();

  const onClose = () => {
    setIsOpen(false);
  };

  const onDelete = async () => {
    onClose();
    setCreateProjectModalOpen(false);
    deleteEditorConnection(connector.id);
  };

  return (
    <BaseModal hasCloseIcon onClose={() => setIsOpen(false)} open={isOpen} title="Supprimer la connexion à l'éditeur">
      <DialogContent sx={{py: 3}}>
        <Typography fontFamily={FONT_FAMILIES.BODY} fontSize={14}>
          Les dossiers utilisant cette connexion continueront à se mettre à jour. Utiliser cette option si vous souhaitez importer des dossiers depuis un autre compte de l'éditeur{' '}
          <b>{connector.name}</b>.
        </Typography>
      </DialogContent>
      <DialogActions sx={{width: '100%', justifyContent: 'center'}}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={onDelete}>
          Supprimer
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

DeleteEditorConnectionModal.propTypes = {
  isOpen: bool.isRequired,
  setIsOpen: func.isRequired
};

export default DeleteEditorConnectionModal;
